import React, { useState, useEffect } from 'react';
import './ProfilePictureModal.css';
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface ProfilePictureModalProps {
    setProfileImage: (value: boolean) => void;
    currentImage: string | null;
    onSave: (image: string | null) => void;
}

const ProfilePictureModal: React.FC<ProfilePictureModalProps> = ({ setProfileImage, currentImage, onSave }) => {
    const defaultImage = "/svg/blank profile picture.svg";
    const [profileImageState, setProfileImageState] = useState<string>(defaultImage);

    useEffect(() => {
        if (currentImage) {
            setProfileImageState(currentImage);
        } else {
            setProfileImageState(defaultImage);
        }
    }, [currentImage]);

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = () => {
                const result = reader.result as string;
                setProfileImageState(result);
                onSave(result);
            };
            reader.readAsDataURL(file);
        }
        event.target.value = "";
    };

    const onRemove = () => {
        setProfileImageState(defaultImage);
        onSave(null);
        console.log("Profile picture removed.");
    };

    const isUploaded = profileImageState !== defaultImage && profileImageState !== "/default.png" && !profileImageState.includes("googleusercontent.com");

    return (
        <>
            <div className="profile-container" style={{ position: 'relative' }}>
                <div style={{ position: 'absolute', top: '10px', right: '10px' }}>
                    <IconButton size="small" onClick={() => setProfileImage(false)}>
                        <CloseIcon className="feedback-popup-close-button" />
                    </IconButton>
                </div>
                <h3>Profile Picture</h3>
                <div className="profile-image-container">
                    <img
                        src={profileImageState}
                        alt="Profile"
                        className="profile-image"
                    />
                </div>
                <div className="button-group" >
                    <div className='fileContainer'>
                        <button className="profile-action-button" onClick={() => document.getElementById("file-input")?.click()} style={{ width: '100%' }}>
                            Change
                        </button>
                        <input
                            id="file-input"
                            type="file"
                            accept="image/*"
                            className='hidden-file-input'
                            onChange={handleFileChange}
                            style={{ display: 'none' }}
                        />
                    </div>
                    <button className="profile-action-button" onClick={onRemove} disabled={!isUploaded} style={{ width: '100%', opacity: !isUploaded ? 0.5 : 1, cursor: !isUploaded ? 'not-allowed' : 'pointer' }}>
                        Remove
                    </button>
                </div>
            </div>
        </>
    );
};

export default ProfilePictureModal;
